/**
 * Display-only formatter for logged/actual hours stored as decimal hours.
 * Examples: 2.35 -> "2h 21m", 0.5 -> "30m", 2 -> "2h", 0/null -> "0h 0m"
 */
export const formatActualHours = (hours) => {
  const numericHours = Number(hours);

  if (hours == null || hours === "" || Number.isNaN(numericHours) || numericHours <= 0) {
    return "0h 0m";
  }

  const totalMinutes = Math.round(numericHours * 60);

  if (totalMinutes <= 0) {
    return "0h 0m";
  }

  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  if (h === 0) {
    return `${m}m`;
  }

  if (m === 0) {
    return `${h}h`;
  }

  return `${h}h ${m}m`;
};

export default formatActualHours;
